module.exports = __webpack_public_path__ + "img/section19.935228f6.png";